import { Deserializable } from "../shared/models/deserializable.model";
import { Property } from "./property";

export class Contact implements Deserializable {
   accountId: number;
   id: number;
   isBusiness: boolean;
   business_name: string;
   title: string;
   first_name: string;
   last_name: string;
   email: string;
   phone1: string;
   phone2: string;
   address1: string;
   address2: string;
   city: string;
   postcode: string;
   notes: string;
   createdAt: string;
   updatedAt: string;
   properties: Property[];

   deserialize(input: any) {
   	Object.assign(this, input);

      if (input.properties && input.properties.length > 0) {
         this.properties = input.properties.map((property: any) => new Property().deserialize(property));

         // Sort them by newest at the top
         this.properties.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
      }
      else {
         this.properties = [];
      }

      return this;
   }

  get mainName(): string {
      if (this.isBusiness) {
         // Business is the main name
         return this.business_name;
      }
      else {
         // Normal name is the main name
         return this.first_name + ' ' + this.last_name;
      }
  }

  get secondaryName(): string {
     if (this.isBusiness) {
         return this.first_name + ' ' + this.last_name;
      }
      else {
         return this.business_name;
      }
  }

  get invoiceDisplay(): string {
   return this.email ? `${this.mainName} - ${this.email}` : this.mainName;
   }
}